
// Note:  some click handlers also need to implement interface IDrawerComponentLiaison.
export class DrawerComponentLiaisonBase {
    // Properties.
    private initializationComplete: boolean = false;

    // Constructor.
    protected constructor() { }

    // Implement part of interface IDrawerComponentLiaison.
    public get LiaisonHasInitialized(): boolean {
        return this.initializationComplete;
    }

    // Implement methods available to derived classes.
    protected initializationHasCompleted(): void {
        this.initializationComplete = true;
    }
    protected initializationHasStarted(): void {
        this.initializationComplete = false;
    }
}

// THE FOLLOWING COMMENTED OUT CODE PROVIDES A BIT OF A TEMPLATE FOR DEFINING CONCRETE DRAWER COMPONENT LIAISON CLASSES.
/*
export class TbdDrawerComponentLiaison extends DrawerComponentLiaisonBase implements IDrawerComponentLiaison {
    public constructor(private formsComponent: FormsComponent) {
        super();

        this.initializationHasCompleted();
    }

    // Implement IDrawerComponentLiaison methods.
    public get HandlesDrawerComponentTag(): string {
        return 'app-TBD';
    }

    public drawerComponentInitialized(drawerComponentParam: any): void {
        // Cast from the drawer component base class to the specific drawer component class.
        // TO DO:  CAST TO THE DRAWER COMPONENT CLASS HANDLED BY THIS CLASS.

        // Set the drawer's input value(s).
        // TO DO:  SET INPUT VALUES.

        // Listen for the component's outputs.
        // TO DO:  SUBSCRIBE TO OUTPUT EVENTS.
    }

    // Helper methods.
    // TO DO:  DEEFINE HELPER METHODS.
}
*/
